import {useState, useEffect, useContext} from "react"
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import TextractContext from "../../../contexts/TextractContext"


export default ({utilities, selectedUtility, setSelectedUtility}) => {
  const {selectedTextractBill} = useContext(TextractContext)
  useEffect(_ => {
    if (utilities[0] && !selectedUtility) {
      let utilityIdx = 0
      if (selectedTextractBill && selectedTextractBill.utility_company_id) {
        utilityIdx = utilities.findIndex(u => u.id == selectedTextractBill.utility_company_id)
      }
      setSelectedUtility(utilities[utilityIdx != -1 ? utilityIdx : 0])
    }
  }, [utilities])

  useEffect(_ => {
    console.log(utilities)
    console.log(selectedUtility)
  }, [selectedUtility])

  const handleUtilityChange = e => setSelectedUtility(e.target.value)


  const handleChange = (event, newValue) => {
    console.log(newValue)
    handleUtilityChange({
      target: {
        value: newValue,
      },
    });
  };

  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <Autocomplete
      id="utility-autocomplete"
      options={utilities}
      getOptionLabel={(option) => option.name + (option.has_unmapped ? " 🔴" : "")}
      style={{ width: 550 }}
      value={selectedUtility || null} // Set to null if no utility is selected
      onChange={handleChange}
      renderInput={(params) => (
        <TextField {...params} label="Utility" variant="outlined" />
        )}
        getOptionSelected={(option, value) => option.id === value.id}
      />
    </div>
    )
  }